module.exports = __webpack_public_path__ + "static/media/okrFlag.e2bb7289.svg";